export const NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES = {
  normal: false,
  notNormal: false,
  declined: false,
  normalDetails: [],
  notNormalDetails: [],
  notes: "",
};

export const BACK_AND_SPINE_FORM_INITIAL_VALUES = {
  sections: {
    generalAppearanceBackAndSpine: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
    spineBackAndSpine: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
    anusBackAndSpine: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type NewbornPostpartumPhysicalExamsBackAndSpineSections =
  keyof typeof BACK_AND_SPINE_FORM_INITIAL_VALUES.sections;
